import React from 'react'
import PropTypes from 'prop-types'
import { StyledSubtitle, StyledTitle, StyledTitlesWrapper } from './styles'

const GameTileText = (props) => {
  const { title, providerName, baseProvidersSlug, gameSlug } = props

  return (
    <StyledTitlesWrapper>
      <StyledTitle>{title}</StyledTitle>
      <StyledSubtitle to={`/${baseProvidersSlug}/${gameSlug}/`}>
        {providerName}
      </StyledSubtitle>
    </StyledTitlesWrapper>
  )
}

GameTileText.defaultProps = {
  title: '',
  providerName: '',
  gameSlug: '',
  baseProvidersSlug: '',
}

GameTileText.propTypes = {
  title: PropTypes.string,
  providerName: PropTypes.string,
  gameSlug: PropTypes.string,
  baseProvidersSlug: PropTypes.string,
}

export { GameTileText }
